/**
 * StadiumBackdrop — decorative stadium scene behind the character:
 * twinkling dots, corner light beams, a radial purple glow, converging pitch
 * lines, and a soft ground shadow. Purely visual; no interaction.
 */

import { View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Svg, {
  Defs,
  Ellipse,
  Line,
  LinearGradient as SvgLinearGradient,
  RadialGradient,
  Stop,
} from 'react-native-svg';
import { TwinkleDots } from './TwinkleDots';
import { stadiumBackdropStyles as styles } from './StadiumBackdrop.styles';

const BEAM_FILL = ['rgba(255,255,255,0.10)', 'rgba(255,255,255,0)'] as const;

/** x-origins of the converging pitch lines (design coordinates, 360-wide frame). */
const PITCH_LINES = [60, 130, 200, 270, 340, 180, 110, 250];

export function StadiumBackdrop() {
  return (
    <View style={styles.root} pointerEvents="none">
      <TwinkleDots />

      <LinearGradient
        colors={BEAM_FILL}
        start={{ x: 0, y: 0 }}
        end={{ x: 0.8, y: 1 }}
        style={styles.beamLeft}
      />
      <LinearGradient
        colors={BEAM_FILL}
        start={{ x: 1, y: 0 }}
        end={{ x: 0.2, y: 1 }}
        style={styles.beamRight}
      />

      <Svg style={styles.scene} viewBox="0 0 360 236" preserveAspectRatio="none">
        <Defs>
          <RadialGradient id="glow" cx="50%" cy="100%" rx="50%" ry="60%">
            <Stop offset="0" stopColor="#A78BFA" stopOpacity={0.22} />
            <Stop offset="1" stopColor="#A78BFA" stopOpacity={0} />
          </RadialGradient>
          <SvgLinearGradient id="pitch" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0" stopColor="#A78BFA" stopOpacity={0} />
            <Stop offset="1" stopColor="#A78BFA" stopOpacity={0.55} />
          </SvgLinearGradient>
        </Defs>

        <Ellipse cx={180} cy={236} rx={175} ry={72} fill="url(#glow)" />

        {PITCH_LINES.map((x) => (
          <Line
            key={x}
            x1={x}
            y1={236}
            x2={180 + (x - 180) * 0.18}
            y2={150}
            stroke="url(#pitch)"
            strokeWidth={1}
            opacity={0.45}
          />
        ))}
        <Line x1={20} y1={196} x2={340} y2={196} stroke="url(#pitch)" strokeWidth={1} opacity={0.3} />
      </Svg>

      <View style={styles.groundShadow} />
    </View>
  );
}
